module.exports = __webpack_public_path__ + "img/3d_门.59502885.png";